module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1668x2388.48cbd2a8.png";